import { css } from '@/styled-system/css';

export const dynamicMapContainer = css({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  borderRadius: '8px',
});

export const mapElement = css({
  width: '100%',
  height: '100%',
  borderRadius: '8px',
  display: 'block', // Always rendered (not display: none)
  transitionProperty: 'opacity',
  transitionDuration: '0.25s',
  transitionTimingFunction: 'ease-out',
  // Ensure map fills container properly
  '& .gm-style': {
    borderRadius: '8px',
  },
  // Hide Google Maps attribution and all controls for pure map display
  '& .gm-style .gm-style-cc': {
    display: 'none',
  },
  '& .gm-style .gmnoprint': {
    display: 'none', // Hide all controls
  },
});

export const loadingContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  bg: 'hpxGrey100',
});

export const fallbackContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  bg: 'hpxGrey100',
  color: 'hpxGrey600',
  textAlign: 'center',
  padding: '2x',
  gap: '1x',
});

export const fallbackIcon = css({
  fontSize: '2xl',
  opacity: 0.6,
  marginBottom: '1x',
});

export const fallbackText = css({
  fontSize: 'sm',
  fontWeight: '500',
  color: 'hpxGrey600',
});

export const fallbackSubtext = css({
  fontSize: 'tiny',
  color: 'hpxGrey500',
  maxWidth: '200px',
  lineHeight: '1.4',
});
